export default {
  // Cookies page
  cookiesTitle: 'Zásady cookies',
  cookiesSubtitle: 'Spravujte své předvolby cookies a souhlas se sledováním.',
  cookiesUpdated: 'naposledy aktualizováno: 10. ledna 2026',
  cookiesManifest: 'Podrobný přehled',
  cookiesPrivacyPre: 'Více informací o tom, jak nakládáme s vašimi údaji, najdete v našich úplných',
  cookiesPrivacyLink: 'Zásadách ochrany osobních údajů',
  cookiesIntro:
    'PixelKey používá soubory cookies a podobné technologie, aby web zůstal stabilní a bezpečný, zlepšil váš zážitek a analyzoval, jak je platforma využívána. Své předvolby spravujte níže.',
  cookiesPrefsTitle: 'Vaše předvolby',
  cookiesRowEssential: 'Nezbytné',
  cookiesRowEssentialDesc:
    'Základní cookies nutné pro bezpečné fungování platformy (např. správa relace, pokladna). Nelze je vypnout.',
  cookiesRowAnalytics: 'Analytické',
  cookiesRowAnalyticsDesc:
    'Pomáhají nám pochopit, jak návštěvníci s platformou interagují, a to anonymním sběrem a vykazováním informací.',
  cookiesRowMarketing: 'Marketingové',
  cookiesRowMarketingDesc: 'Slouží ke sledování návštěvníků napříč weby za účelem zobrazení relevantních reklam.',
  cookiesSaved: 'Předvolby uloženy.',
  cookiesSave: 'Uložit předvolby',

  cookiesInUseTitle: 'Používané cookies',
  cookiesColName: 'Název',
  cookiesColProvider: 'Poskytovatel',
  cookiesColPurpose: 'Účel',
  cookiesColType: 'Typ',
  cookiesColExpiry: 'Platnost',

  cookiesGroupEssential: 'Nezbytné (nezbytně nutné)',
  cookiesGroupAnalytics: 'Analytika a výkon',
  cookiesGroupMarketing: 'Marketing a cílení',

  cookieSessionPurpose: 'Udržuje stav aktivní uživatelské relace.',
  cookieCsrfPurpose: 'Zabraňuje útokům typu Cross-Site Request Forgery.',
  cookieGaPurpose: 'Registruje jedinečné ID pro generování statistických údajů.',
  cookiePerfPurpose: 'Sleduje doby načítání a latenci.',
  cookieFbpPurpose: 'Sleduje konverze a cílí zobrazování reklam.',

  cookieExpirySession: 'Relace',
  cookieExpiry1Day: '1 den',
  cookieExpiry2Years: '2 roky',
  cookieExpiryPersistent: 'Trvalá',
  cookieExpiry3Months: '3 měsíce',
  cookieTypeHttp: 'HTTP',
  cookieTypeLocalStorage: 'HTML5 Local Storage',

  cookiesNotes:
    'Změna těchto nastavení může vyžadovat opětovné načtení stránky, aby se plně projevila. Úplný přehled o tom, jak nakládáme s vašimi údaji, najdete v našich kompletních zásadách.',
  cookiesReadFullPolicy: 'Přečíst úplné zásady ochrany osobních údajů',

  // Terms page
  termsTitle: 'Obchodní podmínky',
  termsUpdated: 'naposledy aktualizováno: 15. května 2026',
  termsContents: 'Obsah',
  termsLegalPre: 'V případě jakýchkoli právních dotazů k těmto podmínkám kontaktujte prosím',
  termsNeedAssistanceTitle: 'Potřebujete pomoc?',
  termsNeedAssistanceBody: 'Pokud máte k těmto podmínkám dotazy, náš tým podpory je tu pro vás.',
  termsContactSupport: 'Kontaktovat podporu',

  termsS1Title: 'Souhlas',
  termsS1P1:
    'Přístupem k platformě PixelKey nebo jejím užíváním vyjadřujete souhlas s těmito obchodními podmínkami. Pokud s těmito podmínkami nesouhlasíte, nesmíte platformu používat ani k ní přistupovat.',
  termsS1P2:
    'Tyto podmínky upravují vaše užívání tržiště, včetně nákupu, doručení a uplatnění digitálních klíčů. Vyhrazujeme si právo tyto podmínky kdykoli aktualizovat.',
  termsS1L1: 'Musí vám být alespoň 18 let nebo mít souhlas rodičů.',
  termsS1L2: 'Nesete odpovědnost za zachování důvěrnosti přihlašovacích údajů ke svému účtu.',

  termsS2Title: 'Licence',
  termsS2P1:
    'Po úspěšné platbě vám PixelKey uděluje nevýhradní, nepřenosnou licenci k užívání zakoupeného digitálního produktového klíče v souladu s licenční smlouvou s koncovým uživatelem (EULA) příslušného vydavatele.',

  termsS3Title: 'Omezení',
  termsS3P1:
    'Zavazujete se nepoužívat platformu k jakýmkoli nezákonným účelům, dále neprodávat klíče získané v rozporu s těmito podmínkami, nepokoušet se obcházet bezpečnostní opatření nebo omezení počtu požadavků ani nenarušovat běžný provoz služby.',
  termsS3P2:
    'Automatizované získávání dat, další prodej nebo hromadná extrakce klíčů či nabídek bez našeho písemného souhlasu jsou zakázány.',

  termsS4Title: 'Doručení',
  termsS4P1:
    'Produkty prodávané na PixelKey jsou digitální aktivační klíče doručované elektronicky. Jakmile vaše platba proběhne, klíč je zpřístupněn ve vašem účtu v sekci „Mé objednávky“, obvykle během několika sekund.',
  termsS4P2:
    'Jste odpovědní za aktivaci klíče na správné platformě (např. Steam, Epic Games) a za kontrolu případných regionálních omezení uvedených na stránce produktu před nákupem.',

  termsS5Title: 'Vrácení peněz',
  termsS5P1:
    'Protože digitální klíče jsou po odkrytí nevratné, vrácení peněz je možné pouze u klíčů, které nebyly odkryty ani aktivovány. Odkrytí klíče představuje spotřebování digitálního produktu a znamená vzdání se práva na odstoupení od smlouvy.',
  termsS5P2:
    'Pokud je klíč vadný nebo jej nelze aktivovat z důvodů na straně PixelKey, kontaktujte náš tým podpory; situaci prošetříme a v odůvodněných případech poskytneme náhradní klíč nebo vrácení peněz.',

  termsS6Title: 'Odpovědnost',
  termsS6P1:
    'V maximálním rozsahu povoleném zákonem nenese PixelKey odpovědnost za žádné nepřímé, náhodné, zvláštní ani následné škody vzniklé v souvislosti s vaším užíváním platformy, a to ani v případě, že byl na možnost takových škod upozorněn.',

  termsS7Title: 'Ukončení',
  termsS7P1:
    'Váš účet můžeme kdykoli pozastavit nebo zrušit, pokud porušíte tyto podmínky nebo pokud se důvodně domníváme, že je váš účet zapojen do podvodné či zneužívající činnosti. Svůj účet můžete kdykoli zrušit v nastavení účtu.',

  termsS8Title: 'Změny',
  termsS8P1:
    'Vyhrazujeme si právo tyto podmínky kdykoli změnit. Podstatné změny se projeví v datu „naposledy aktualizováno“ výše a pokračováním v užívání platformy po nabytí účinnosti změn vyjadřujete souhlas s upravenými podmínkami.',

  termsS9Title: 'Rozhodné právo',
  termsS9P1:
    'Tyto podmínky se řídí a vykládají v souladu s právními předpisy Lotyšska a vy se podřizujete nevýlučné jurisdikci tamních soudů pro řešení jakýchkoli sporů.',

  termsS10Title: 'Kontakt',
  termsS10P1:
    'Dotazy k těmto obchodním podmínkám můžete směřovat na náš tým podpory. Na všechny právní a účetní dotazy se snažíme odpovědět do dvou pracovních dnů.',
};
